const initialState = {
	average: 100,
	canVote: true,
	numberOfVotes: 1,
	isLoading: false,
	position: 0,
	error: ''
}

export default function betaradesVotingReducer(state = initialState, action) {
	switch (action.type) {
		case 'ASYNC_FETCH_RATINGS_REQUEST':
			return {
				...state,
				isLoading: true
			}
		case 'ASYNC_FETCH_RATINGS_SUCCESS': {
			const { canVote, numberOfVotes, average } = action.data;

			return {
				...state,
				canVote,
				numberOfVotes: numberOfVotes ? numberOfVotes : state.numberOfVotes,
				average: average ? average : state.average,
				isLoading: false,
			}

		}
		case 'ASYNC_FETCH_RATINGS_ERROR': {
			const { error } = action;

			return {
				...state,
				isLoading: false,
				error
			}
		}
		case 'ASYNC_SUBMIT_VOTE_REQUEST':
			return {
				...state,
				isLoading: true
			}
		case 'ASYNC_SUBMIT_VOTE_SUCCESS': {
			const { canVote, numberOfVotes, average } = action.data;

			return {
				...state,
				canVote,
				numberOfVotes,
				average,
				isLoading: false,
			}
		}
		case 'ASYNC_SUBMIT_VOTE_ERROR': {
			const { error } = action;

			return {
				...state,
				isLoading: false,
				error
			}
		}
		case 'SET_POSITION_VALUE': {
			const { position } = action;

			return {
				...state,
				position
			}
		}
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/state/reducer.js